<template>
  <div>
    <div v-if="isExistSearchResult">
      <table id="data-table" class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col">企業コード</th>
            <th scope="col">企業名称</th>
            <th scope="col">企業情報作成日</th>
            <th scope="col">手入力棚卸<br>許可区分</th>
            <th scope="col">簡易認証<br>許可区分</th>
            <th scope="col">棚卸情報削除<br>許可区分</th>
            <th scope="col">棚卸完了解除<br>許可区分</th>
            <th scope="col">CSVファイル UTF-8設定</th>
            <th scope="col">帳簿未使用区分<br></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="value in enterpriseList" :key="value.enterpriseCode">
            <th class="table-cell-wrap mw200 mxw250" scope="row">
              <router-link :to="{ name: 'enterprise-edit', params: { mode: 'update', enterpriseCode: value.enterpriseCode }}">
                {{ value.enterpriseCode }}
              </router-link>
            </th>
            <td class="table-cell-wrap mw200 mxw250">{{ value.enterpriseName }}</td>
            <td class="table-cell-wrap mw200 mxw200">{{ value.createDateTime | moment('YYYY-MM-DD') }}</td>
            <td class="table-cell-wrap mw100 mxw100">{{ value.manualInventoryPermitDiv === 0 ? '可' : '不可' }}</td>
            <td class="table-cell-wrap mw100 mxw100">{{ value.simpleAuthenticationDiv === 0 ? '可' : '不可' }}</td>
            <td class="table-cell-wrap mw100 mxw100">{{ value.inventoryDeleteDiv === 0 ? '可' : '不可' }}</td>
            <td class="table-cell-wrap mw100 mxw100">{{ value.inventoryCancelDiv === 0 ? '可' : '不可' }}</td>
            <td class="table-cell-wrap mw100 mxw100">{{ value.bomAttachDiv === 0 ? 'BOM有' : 'BOM無' }}</td>
            <td class="table-cell-wrap mw100 mxw100">{{ value.accountbookDiv === 0 ? '帳簿あり' : '帳簿なし' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      検索結果は0件です。
    </div>
  </div>
</template>

<script>
export default {
  name: 'enterprise-search-result',
  props: {
    enterpriseList: Array,
    isExistSearchResult: false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/EnterpriseSearchResult.vue